import { Inject, Injectable, Injector } from '@angular/core';

import { Utilities_FlowService } from './Utilities.flow.index';
import { Invoices_FlowService } from './Invoices.flow.index';
import { Notifications_FlowService } from './Notifications.flow.index';
import { Inventory_FlowService } from './Inventory.flow.index';
import { FootPrintApiManager_FlowService } from './FootPrintApiManager.flow.index';

import { app_custom_get_report_data_flowService } from './app.flow.index';

import { $types } from './app.types'

@Injectable({ providedIn: 'root' })
export class app_FlowService {

  constructor(
    private injector: Injector
  ) {
    this.Utilities = this.injector.get(Utilities_FlowService);
    this.Invoices = this.injector.get(Invoices_FlowService);
    this.Notifications = this.injector.get(Notifications_FlowService);
    this.Inventory = this.injector.get(Inventory_FlowService);
    this.FootPrintApiManager = this.injector.get(FootPrintApiManager_FlowService);
  }

    public Utilities: Utilities_FlowService;
    public Invoices: Invoices_FlowService;
    public Notifications: Notifications_FlowService;
    public Inventory: Inventory_FlowService;
    public FootPrintApiManager: FootPrintApiManager_FlowService;
  public app: app_FlowService = this;

  // injecting lazily in order to avoid circular dependencies
  private _custom_get_report_data_flow: app_custom_get_report_data_flowService;
  public async custom_get_report_data_flow(inParams: { package_name: string, report_name: string, inputs?: any }): Promise< { report_data?: Blob }> {
    if(!this._custom_get_report_data_flow) {
      this._custom_get_report_data_flow = this.injector.get(app_custom_get_report_data_flowService);
    }
    return this._custom_get_report_data_flow.run(inParams);
  }
}
